import { useState } from 'react';

// The product thumbnail beside a reorder item.
//
// Three states, kept visually distinct rather than collapsed into one:
//   - still resolving  → a quiet placeholder, so the row doesn't jump
//   - a real og:image  → the picture
//   - no image / dead  → a link glyph, NOT a broken-image icon
//
// The last one matters: plenty of shops publish no og:image at all, and a
// site that simply doesn't advertise a picture isn't an error worth showing
// as one. The link still works either way.
export default function LinkThumbnail({ href, preview, alt }) {
  const [failed, setFailed] = useState(false);

  const src = preview?.status === 'ok' ? preview.image_url : null;
  const resolving = !preview;

  const inner =
    src && !failed ? (
      <img
        src={src}
        alt={alt || preview?.title || ''}
        loading="lazy"
        // The image is hotlinked from the shop, so don't leak which page of
        // this dashboard requested it.
        referrerPolicy="no-referrer"
        onError={() => setFailed(true)}
        draggable={false}
      />
    ) : (
      <span className="toorder-thumb-fallback" aria-hidden="true">
        {resolving ? '' : '🔗'}
      </span>
    );

  const title = preview?.title || preview?.error || undefined;

  if (!href) return <span className={thumbClass(resolving)}>{inner}</span>;

  return (
    <a
      className={thumbClass(resolving)}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      title={title}
      // The row's own click targets are elsewhere; keep the thumbnail from
      // also toggling the item's checkbox.
      onClick={(e) => e.stopPropagation()}
    >
      {inner}
    </a>
  );
}

function thumbClass(resolving) {
  return 'toorder-thumb' + (resolving ? ' resolving' : '');
}
